import { useEffect } from "react";

export const useFavicon = (iconUrl?: string | null) => {
  useEffect(() => {
    if (!iconUrl) return;

    let link =
      (document.querySelector("link[rel='icon']") as HTMLLinkElement | null) ||
      (document.querySelector("link[rel='shortcut icon']") as HTMLLinkElement | null);

    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }

    link.href = iconUrl;
  }, [iconUrl]);
};
